module.exports = __webpack_public_path__ + "static/media/eyeclosed.d280f050.png";